import { createFileRoute } from '@tanstack/react-router';

import { DeletePage } from '../pages/DeletePage';

export const Route = createFileRoute('/delete')({
  component: DeletePage,
});
